import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'

import { GetSimulacaoPdfService } from '@/http/get-simulacao-pdf.service'
import { showToast } from '@/infra/sonner'
import { Pdf } from '@/utils/pdf.entity'

export const useBaixarPDFSimulacao = () => {
  const { t } = useTranslation('simulador')
  return useMutation<void, AxiosError, string, unknown>({
    mutationFn: async (simulacaoId: string) => {
      const response = await new GetSimulacaoPdfService().execute(simulacaoId)
      const contentDisposition = response.headers['content-disposition']
      const filename = Pdf.extractFilename(contentDisposition) ?? `${simulacaoId}.pdf`
      Pdf.download(response.data, filename)
    },
    onSuccess: () => {
      showToast({
        message: t('salvar_simulacao.baixar_pdf.titulo'),
        variant: 'success',
        closeButton: true,
      })
      Pdf.cancelDownload()
    },
    onError: async (err) => {
      if (!(err.response?.data instanceof Blob)) return
      const error = await err.response.data.text()
      const parsedError = JSON.parse(error)
      const message = parsedError.length ? parsedError : t('salvar_simulacao.baixar_pdf_erro.titulo')
      showToast({ message, variant: 'error', closeButton: true })
    },
  })
}
